module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8455/img/spinner.png"